<template lang="pug">
section
    Teaser(:key="form.id")
        el-row.no-margin(:gutter="40")
            el-col(:lg="14" :md="12")
                el-form-item(:label="$t('Title')" prop="title")
                    el-input(v-model="title" maxlength="255" show-word-limit)
            el-col(:lg="10" :md="12")
                el-form-item(:label="$t('URL Key')" prop="key")
                    .url-key-input
                        el-input(v-model="key" maxlength="255" show-word-limit)
                        el-tooltip(effect="dark" :content="$t('Copy URL')" placement="top")
                            el-button.url-copy-button(
                                icon="el-icon-fa-copy far"
                                :disabled="!publicUrl"
                                @click.prevent="copyPublicUrl"
                            )
    Main(v-if="config" :page="form" :config="config" :section-options="sectionOptions")
</template>

<i18n>
{
    "de": {
        "Title": "Titel",
        "URL Key": "URL Schlüssel",
        "Copy URL": "URL kopieren",
        "URL copied to clipboard!": "URL wurde in die Zwischenablage kopiert!",
        "URL could not be copied.": "URL konnte nicht kopiert werden."
    }
}
</i18n>

<script>

import _ from 'lodash'
import copy from 'copy-text-to-clipboard';
import { useSetupStore, usePageStore } from '@/stores'

import Main from '@/components/Page/Main'
import Teaser from './Partials/Teaser'

export default {
    name: 'CategoryPageMain',
    components: {
        Main,
        Teaser,
    },
    computed: {
        pageStore() {
            return usePageStore()
        },
        form() {
            return this.pageStore.form
        },
        options() {
            return this.pageStore.options
        },
        id() {
            return _.get(this.form, 'id')
        },
        title: {
            get() {
                return _.get(this.form, 'title', '')
            },
            set(value) {
                this.pageStore.setFormTitle(value)
                if (! this.id) {
                    const requestedKey = _.kebabCase(value)
                    let key = requestedKey

                    // var i = 0
                    // while (this.usedKeys.indexOf(key) >= 0) {
                    //     ++ i
                    //     key = `${requestedKey}-${i}`
                    // }

                    this.pageStore.setFormKey(key)
                }
            }
        },
        key: {
            get() {
                return _.get(this.form, 'key', '')
            },
            set(value) {
                this.pageStore.setFormKey(value)
            }
        },
        config() {
            const view = _.get(this.form, 'view')
            const config = _.get(this.activeCms, 'config.template.pages', [])
                .find(item => item.view === view)

            return config
        },
        sectionOptions() {
            const sections = _.get(this.config, 'sections') || []

            let options = []
            sections.forEach(section => {
                const config = _.get(this.activeCms, 'config.template.sections', [])
                    .find(item => item.key === section.key)

                const option = {...section, ...config}
                // TODO: initialize section
                options.push(option)
            })

            return options
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        categoryKey() {
            return _.get(this.$route, 'params.key', '');
        },
        publicUrl() {
            const baseUrl = _.get(this.activeCms, 'domains.0.base_url', '');
            const categoryKey = this.categoryKey;
            const slug = _.get(this.form, 'key', '');
            if (!baseUrl || !categoryKey || !slug) return '';

            let protocol = 'http:';
            if (process.env.NODE_ENV === 'production') protocol = window.location.protocol;

            const normalizedBaseUrl = String(baseUrl)
                .replace(/^https?:\/\//, '')
                .replace(/\/+$/, '');
            const normalizedCategoryKey = String(categoryKey).replace(/^\/+|\/+$/g, '');
            const normalizedSlug = String(slug).replace(/^\/+|\/+$/g, '');

            return `${protocol}//${normalizedBaseUrl}/${normalizedCategoryKey}/${normalizedSlug}`;
        },
    },
    methods: {
        async copyPublicUrl() {
            if (!this.publicUrl) return;

            try {
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(this.publicUrl);
                } else {
                    copy(this.publicUrl);
                }

                this.$message.success(this.$t('URL copied to clipboard!'));
            } catch (e) {
                try {
                    copy(this.publicUrl);
                    this.$message.warning(this.$t('URL copied to clipboard!'));
                } catch (fallbackError) {
                    this.$message.error(this.$t('URL could not be copied.'));
                }
            }
        },
    }
}
</script>

<style lang="sass" scoped>
.url-key-input
    display: flex
    align-items: flex-start
    gap: 8px
    &::v-deep .el-input
        flex: 1

.url-copy-button
    flex-shrink: 0
    border-radius: 6px
</style>
